import { StyledConnectionCard } from "./style";
import { Link, Stack } from "@mui/material";

const ConnectionsCard = ({ src, title }) => (
  <StyledConnectionCard>
    <Stack height={120} width={100} justifyContent={"center"}>
      <Link href="https://mn724.com/">
        <img
          src={src}
          alt={title}
          style={{
            width: "100%",
            height: "auto",
            objectFit: "cover",
          }}
        />
      </Link>
    </Stack>
  </StyledConnectionCard>
);

export default ConnectionsCard;
